import { CalendarCheck, PawPrint, ShoppingBasket, TramFront, Trees } from 'lucide-react';

/**
 * Ikony filtrów okolicy — TE SAME co zakładki sekcji „Lokalizacja i okolica” na ofercie
 * (NawigacjaOkolicy / SekcjaOkolicy), zamiast emoji w napisie (Piotr 30.09: filtr i oferta mają
 * mówić jednym językiem). `walk` to na ofercie „Na co dzień” (walkability), stąd koszyk.
 */
export const IKONA_FILTRA_POI = {
  transit: TramFront,
  walk: ShoppingBasket,
  green: Trees,
} as const;

export function IkonaZwierzat({ size = 14 }: { size?: number }) {
  return <PawPrint style={{ width: size, height: size }} aria-hidden />;
}

export function IkonaOdZaraz({ size = 14 }: { size?: number }) {
  return <CalendarCheck style={{ width: size, height: size }} aria-hidden />;
}
